import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { apiService } from '../services/api';

const YearHome: React.FC = () => {
  const { year } = useParams<{ year: string }>();
  const [groups, setGroups] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!year) return;
      
      setIsLoading(true);
      setError(null);
      
      try {
        const teamsData = await apiService.getTeams();
        const yearTeams = teamsData.filter(team => team.year === parseInt(year));
        const uniqueGroups = Array.from(new Set(yearTeams.map(team => team.group))).sort();
        setGroups(uniqueGroups);
      } catch (err) {
        setError('Failed to load data');
        console.error('Error fetching data:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [year]);

  if (isLoading) return <div style={{ textAlign: 'center', padding: '20px' }}>Loading...</div>;
  if (error) return <div style={{ textAlign: 'center', padding: '20px', color: 'red' }}>{error}</div>;
  if (!year) return <div style={{ textAlign: 'center', padding: '20px' }}>Invalid URL parameters</div>;

  return (
    <div className="yearhome-root" style={{ 
      maxWidth: '1200px', 
      margin: '0 auto', 
      padding: '0 20px 20px 20px',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#e3f2fd'
    }}>
      {/* Navigation */}
      <div style={{ marginBottom: '40px', paddingTop: '20px' }}>
        <Link 
          to="/" 
          style={{ 
            color: '#0066cc', 
            textDecoration: 'none', 
            fontSize: '16px',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          ← 返回
        </Link>
      </div>

      {/* Header */}
      <div className="yearhome-header" style={{ 
        textAlign: 'center',
        marginBottom: '60px'
      }}>
        <h1 style={{ 
          fontSize: '3rem', 
          color: '#2d3748',
          marginBottom: '12px',
          fontWeight: '700'
        }}>
          Summer League {year}
        </h1>
        <div style={{
          width: '60px',
          height: '4px',
          backgroundColor: '#3182ce',
          margin: '0 auto',
          borderRadius: '2px'
        }}></div>
      </div>

      {/* Full year schedule */}
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <Link
          to={`/summer-league/${year}/schedule`}
          style={{
            display: 'inline-block',
            backgroundColor: '#3182ce',
            color: '#fff',
            textDecoration: 'none',
            padding: '12px 28px',
            borderRadius: '8px',
            fontSize: '1.1rem',
            fontWeight: 600,
            boxShadow: '0 4px 12px rgba(49, 130, 206, 0.3)',
          }}
        >
          完整賽程
        </Link>
      </div>

      {/* Groups Horizontal Layout */}
      <div className="yearhome-groups-row" style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        gap: '30px',
        marginBottom: '40px',
        padding: '10px 0',
        flexWrap: 'wrap'
      }}>
        {groups.map((group) => (
          <Link 
            key={group}
            to={`/summer-league/${year}/${group}`}
            style={{
              textDecoration: 'none',
              color: 'inherit',
              display: 'block'
            }}
          >
            <div className="yearhome-group-card" style={{
              backgroundColor: '#e3f2fd',
              borderRadius: '16px',
              padding: '30px 20px',
              textAlign: 'center',
              boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
              border: '2px solid transparent',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              position: 'relative',
              overflow: 'hidden',
              minWidth: '280px',
              flexShrink: 0
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 15px 35px rgba(0,0,0,0.15)';
              e.currentTarget.style.borderColor = '#3182ce';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.1)';
              e.currentTarget.style.borderColor = 'transparent';
            }}
            >
              {/* Icon */}
              <div className="icon" style={{
                width: '60px',
                height: '60px',
                backgroundColor: '#3182ce',
                borderRadius: '50%',
                margin: '0 auto 15px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '24px',
                color: 'white'
              }}>
                🏀
              </div>
              {/* Title */}
              <h3 style={{
                fontSize: '1.4rem',
                color: '#2d3748',
                marginBottom: '8px',
                fontWeight: '600'
              }}>
                Group {group}
              </h3>
              {/* Description */}
              <p style={{
                fontSize: '0.9rem',
                color: '#718096',
                marginBottom: '15px',
                lineHeight: '1.4'
              }}>
                查看 {year} 年 {group} 組
              </p>
              {/* Arrow */}
              <div style={{
                fontSize: '1.2rem',
                color: '#3182ce',
                fontWeight: 'bold'
              }}>
                →
              </div>
            </div>
          </Link>
        ))}
      </div>

      {/* Footer Info */}
      <div style={{
        textAlign: 'center',
        color: '#a0aec0',
        fontSize: '0.9rem'
      }}>
        <p>選擇上方組別開始瀏覽</p>
      </div>
    </div>
  );
};

export default YearHome;
